import ElementoGridExtrusion from '../../components/ecommerce/extrusion/ElementoGridExtrusion'
import i18n from '../../lang/idiomas'

export const obtenerGruposBusqueda = (exGrupos, onClick) => {
  return (
    <div className='tt-menu-extrusion row resultados-busqueda'>
      {!exGrupos?.grupos?.grupos || exGrupos.grupos.grupos.length === 0 ? (
        ''
      ) : (
        <h6>{i18n.t('articulos_extrusion.grupoobt')}</h6>
      )}
      {!exGrupos?.grupos?.grupos || exGrupos.grupos.grupos.length === 0
        ? ''
        : exGrupos.grupos.grupos.map((grupo, index) => {
            return (
              <ElementoGridExtrusion
                id={grupo.id}
                key={grupo.id + index}
                className={'col-4'}
                codigoGrupo={grupo.codigo}
                nombreGrupo={grupo.nombre}
                onClick={onClick}
                imagen={grupo.imagen}
                nombreDisplayed={grupo.nombre}
                esBusqueda={true}
              />
            )
          })}
    </div>
  )
}

export const obtenerSeriesBusqueda = (exSeries, onClick) => {
  return (
    <div className='tt-menu-extrusion row resultados-busqueda'>
      {!exSeries?.series?.series || exSeries.series.series.length === 0 ? (
        ''
      ) : (
        <h6>{i18n.t('articulos_extrusion.serieobt')}</h6>
      )}
      {!exSeries?.series?.series || exSeries.series.series.length === 0
        ? ''
        : exSeries.series.series.map((serie, index) => {
            return (
              <ElementoGridExtrusion
                key={serie.id + index}
                id={serie.id}
                className={'col-4'}
                codigoGrupo={serie.grupo_perfil}
                codigoSerie={serie.codigo}
                nombreSerie={serie.nombre}
                onClick={onClick}
                imagen={serie.imagen}
                nombreDisplayed={serie.nombre}
                esBusqueda={true}
              />
            )
          })}
    </div>
  )
}

export const obtenerSubseriesBusqueda = (exSubseries, onClick) => {
  return (
    <div className='tt-menu-extrusion row resultados-busqueda'>
      {!exSubseries?.subseries?.subseries || exSubseries.subseries.subseries.length === 0 ? (
        ''
      ) : (
        <h6>{i18n.t('articulos_extrusion.subseobt')}</h6>
      )}
      {!exSubseries?.subseries?.subseries || exSubseries.subseries.subseries.length === 0
        ? ''
        : exSubseries.subseries.subseries.map((subserie, index) => {
            return (
              <ElementoGridExtrusion
                key={subserie.id + index}
                id={subserie.id}
                className={'col-4'}
                codigoGrupo={subserie.grupo_perfil}
                codigoSerie={subserie.codigo_serie}
                codigoSubserie={subserie.codigo}
                nombreSubserie={subserie.nombre}
                onClick={onClick}
                imagen={subserie.imagen}
                nombreDisplayed={subserie.nombre}
                esBusqueda={true}
              />
            )
          })}
    </div>
  )
}

export const obtenerPerfilesBusqueda = (exPerfiles, onClick, modo_listado) => {
  return (
    <div className='tt-menu-extrusion row resultados-busqueda'>
      {!exPerfiles?.perfiles?.perfiles || exPerfiles.perfiles.perfiles.length === 0 ? (
        ''
      ) : (
        <h6>{i18n.t('articulos_extrusion.perfiobt')}</h6>
      )}
      {!exPerfiles?.perfiles?.perfiles || exPerfiles.perfiles.perfiles.length === 0
        ? ''
        : exPerfiles.perfiles.perfiles.map((perfil, index) => {
            return (
              <ElementoGridExtrusion
                key={perfil.id + index}
                id={perfil.id}
                className={'col-4'}
                codigoGrupo={perfil.grupo_serie}
                codigoSerie={perfil.serie}
                codigoSubserie={perfil.subserie_perfil}
                codigoPerfil={perfil.codigo_perfil}
                nombrePerfil={perfil.desc_perfil}
                codigoOriginal={perfil.codigo_original}
                codigoReferencia={perfil.codigo_referencia}
                onClick={onClick}
                nombreDisplayed={perfil.codigo_perfil + ' ' + perfil.desc_perfil}
                esBusqueda={true}
                esPerfil={true}
                modoListado={modo_listado}
              />
            )
          })}
    </div>
  )
}
